<template>
  <v-text-field
    v-model="address"
    dense
    outlined
    :id="addressLookupId"
    ref="autocomplete"
    label="Lookup Address*"
    placeholder
  />
</template>

<script>
import request from "@/modules/request";
import uniqid from "uniqid";

export default {
  name: "AddressLookup",
  props: {
    addressType: {
      type: String,
      required: false,
    },
    currentAddress: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.initializeAutoComplete();
  },
  data() {
    return {
      addressLookupId: `${this.addressType}`,
      autocomplete: null,
      address: this.currentAddress,
      search: null,
      sessionId: uniqid(),
    };
  },
  methods: {
    getStreetNumber(place) {
      const { address_components } = place;
      const component = address_components.find((component) =>
        component.types.includes("street_number")
      );
      return component ? component.long_name : "";
    },
    getRoute(place) {
      const { address_components } = place;
      const component = address_components.find((component) =>
        component.types.includes("route")
      );
      return component ? component.long_name : "";
    },
    getCity(place) {
      const { address_components } = place;
      const component = address_components.find((component) =>
        component.types.includes("locality")
      );
      return component ? component.long_name : "";
    },
    getState(place) {
      const { address_components } = place;
      const component = address_components.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      return component ? component.long_name : "";
    },
    getZipcode(place) {
      const { address_components } = place;
      const component = address_components.find((component) =>
        component.types.includes("postal_code")
      );
      return component ? component.long_name : "";
    },
    initializeAutoComplete() {
      const autocompleteInput = document.querySelector(
        `#${this.addressLookupId}`
      );
      const { getStreetNumber, getRoute, getCity, getState, getZipcode } = this;

      this.autocomplete = new google.maps.places.Autocomplete(
        autocompleteInput,
        {
          types: ["address"],
          sessionId: this.sessionId,
        }
      );
      this.autocomplete.addListener("place_changed", () => {
        const place = this.autocomplete.getPlace();
        const { formatted_address } = place;
        const [streetNumber, route, city, state, zip] = [
          getStreetNumber(place),
          getRoute(place),
          getCity(place),
          getState(place),
          getZipcode(place),
        ];

        this.address = formatted_address;
        this.$emit("select_address", {
          addressType: this.addressType,
          formatted_address,
          address1: `${streetNumber} ${route}`,
          city,
          state,
          zip,
        });
        this.resetSessionId();
      });
    },
    resetSessionId() {
      this.sessionId = uniqid();
    },
  },
};
</script>

<style scoped></style>
